import { createSlice } from '@reduxjs/toolkit';
import { ParticipantConsentFormState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { getParticipantConsentFormThunk } from './thunks';

// Initial State
const initialState: ParticipantConsentFormState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const participantPreferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getParticipantConsentFormThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });

    builder.addCase(getParticipantConsentFormThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });

    builder.addCase(getParticipantConsentFormThunk.rejected.type, (state, { payload }: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset } = participantPreferencesSlice.actions;
export * from './thunks';
export * from './selectors';
export * from './types';
export default participantPreferencesSlice.reducer;
